import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { OneAuthService } from 'core/services/oneauth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (environment.useMockAuth) {
    return next(req);
  }

  // Não enviar token do OneEduca para APIs de terceiros (ex.: consulta de CEP).
  if (!isOwnedApiRequest(req.url)) {
    return next(req);
  }

  const token = inject(OneAuthService).getToken();
  const router = inject(Router);

  if (!token) {
    return next(req);
  }

  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };
  if (!req.headers.has('Accept')) {
    headers['Accept'] = 'application/json';
  }

  return next(req.clone({ setHeaders: headers })).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 503 &&
        (error.error?.code === 'maintenance' ||
          error.error?.maintenance === true)
      ) {
        void router.navigateByUrl('/maintenance');
      }
      return throwError(() => error);
    }),
  );
};

function isOwnedApiRequest(url: string): boolean {
  return (
    url.startsWith(environment.apiUrl) ||
    url.startsWith(environment.authBaseUrl)
  );
}
